import router from "./router";
import store from "./store";
import { Message } from "element-ui";
import NProgress from "nprogress"; // progress bar
import "nprogress/nprogress.css"; // progress bar style
import { getToken, removeToken } from "@/utils/auth"; // get token from cookie
import getPageTitle from "@/utils/get-page-title";
import Router from "vue-router";
NProgress.configure({ showSpinner: false }); // NProgress Configuration

// no redirect whitelist
const whiteList = [
  "/login",
  "/register",
  "/mymerchantsettlementb",
  "/qualificationstep",
  "/qualificationresult",
  "/404"
];

// 检查路由是否存在
function isRouteExist(path) {
  let routeExists = false;
  function checkRoute(routes) {
    routes.forEach(route => {
      if (route.path === path) {
        routeExists = true;
      }
      if (route.children) {
        checkRoute(route.children);
      }
    });
  }
  checkRoute(router.getRoutes());
  return routeExists;
}

// 标记动态路由是否已加载完成
let dynamicRoutesLoaded = false;

router.beforeEach(async (to, from, next) => {
  NProgress.start();
  document.title = getPageTitle(to.meta.title);
  if (to.path === "/login") {
    removeToken();
  }
  const hasToken = getToken();

  if (hasToken) {
    if (to.path === "/login") {
      // if is logged in, redirect to the home page
      next({ path: "/" });
      NProgress.done();
    } else {
      // determine whether the user has obtained his permission roles through getInfo
      const hasRoles = store.getters.roles && store.getters.roles.length > 0;
      if (hasRoles) {
        // 动态路由已加载完成后才检查路由是否存在
        if (dynamicRoutesLoaded) {
          if (!isRouteExist(to.path)) {
            next({
              path: '/404',
              replace: true
            });
            NProgress.done();
            return;
          }
        }
        next();
      } else {
        store
          .dispatch("user/getInfo")
          .then((defaultMenuPath) => {
            NProgress.done();
            store
              .dispatch("user/getStatus")
              .then(() => {
                store
                  .dispatch("GenerateRoutesb", { type: true, id: -1 })
                  .then((accessRoutes) => {
                    // 根据roles权限生成可访问的路由表
                    router.addRoutes(accessRoutes); // 动态添加可访问路由表
                    // 标记动态路由已加载完成
                    dynamicRoutesLoaded = true;
                    // 重新检查路由是否存在
                    if (!isRouteExist(to.path)) {
                      next({
                        path: '/404',
                        replace: true
                      });
                      NProgress.done();
                      return;
                    }
                    next({ path: to.fullPath, replace: true }); // hack方法 确保addRoutes已完成
                  });
              })
              .catch(() => {
               console.log('err')
                next(`/mymerchantsettlementb`);
                NProgress.done();
              });
          })
          .catch((err) => {
            store.dispatch("user/resetToken").then((res) => {
              next(`/login`);
              NProgress.done();
            });
          });
      }
    }
  } else {
    // 未登录状态下检查路由是否存在
    if (whiteList.indexOf(to.path) !== -1) {
      next();
    } else {
      // 检查是否是有效的路由，如果是则要求登录，否则跳转到404
      if (isRouteExist(to.path)) {
        next(`/login`);
      } else {
        next(`/404`);
      }
      NProgress.done();
    }
  }
});

router.afterEach(() => {
  NProgress.done();
});
